export default __webpack_public_path__ + "static/media/SoftwareSection1.229490fd.jpg";